import React, { useContext, useEffect, useState } from 'react'
import { CommonModal, CustomSelect } from 'components'
import { getAddressBookDropdownListData, getAddressBookDropdownListData2, getUnitDropdownListData } from '_services/dropdownServices/dropdownService';
import StorageService from 'utils/StorageServices/StorageServices';
import { errorSchema, utils } from 'helper';
import Loading from 'pages/Loading';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import toast from 'react-hot-toast';
import { UserContext } from 'context';

const SelectUnitLrModal = (props) => {

  let { isOpen, closeModal, selectUnit, nextModal, location_point, consignor_id, firmId } = props;

  const { mastersChild, setMasterDetailsList } = useContext(UserContext);
  const masterChildUnit = mastersChild?.find((i) => i?.label === "Unit");

  const [unitDropdownData, setUnitDropdownData] = useState([])
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    unit_id: {},
  });
  const [formError, setFormError] = useState({});

  // const getDropdownDataUnitList = async () => {
  //   try {
  //     let object = {
  //       company_id: StorageService.getCompanyId(),
  //       limit: 100,
  //       offset: 1,
  //       search: '',
  //       consignor_id:consignor_id,
  //       location_point:location_point
  //     }
  //     // const res = await getUnitDropdownListData(object); // change api unit to account

  //     const res = await getAddressBookDropdownListData(object); // change api unit to account
  //     if (res?.responseCode == 200) {
  //       setLoading(false);
  //       setUnitDropdownData(res?.data?.list?.map((i)=>({...i,name:`${i?.code}${i?.code && i?.name ?" | ":""}${i?.name}`})))
  //     } else {
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     // throw error;
  //   }
  // }

  const fetchUnit = async (search, page, limit) => {
    const res = await getAddressBookDropdownListData2({
      company_id: StorageService.getCompanyId(),
      firm_id: firmId?._id ? firmId?._id : StorageService.getFirmId(),
      offset: page,
      limit,
      search,
      consignor_id: consignor_id,
      location_point: location_point
    });
    if (res?.responseCode === 200) {
      setLoading(false);
      const list = await res?.data?.list?.map((i) => ({ ...i, name: `${i?.code}${i?.code && i?.name ? " | " : ""}${i?.name}`, label: `${i?.code}${i?.code && i?.name ? " | " : ""}${i?.name}`, value: i?._id }))
      if (!formValue?.unit_id?.value) {
        setFormValue((s) => {
          return {
            ...s,
            unit_id: list?.map((el) => {
              return {
                ...el,
                label: el?.name,
                value: el?._id,
              }
            })[0],
          }
        })
      }
      return {
        items: list,
        total: res?.data?.total_record,
      };


    } else {
      setLoading(false);
      toast.error(res?.responseMessage);
    }
  };

  useEffect(() => {
    setLoading(true);
    // getDropdownDataUnitList();
  }, [props?.isOpen, StorageService.getCompanyId()])

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...formValue, [name]: item };
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(stateObj, errorSchema.selectUnitLrModalSchema);
      if (validationResult === true) {
        setFormError({});
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleSubmit = async () => {
    const validationResult = await utils?.checkFormError(formValue, errorSchema.selectUnitLrModalSchema);
    if (utils?.isObjectKeyEmpty(validationResult)) {
      setLoading(true);
      selectUnit(formValue?.unit_id);
      closeModal(false);
      setFormError("");

    } else {
      setFormError(validationResult);
      setLoading(false);
    }
  };

  let unitProps = {
    ...props,
    isLoadding: loading,
    disabled: loading,
    onSubmit: (e) => handleSubmit(e),
  }

  const addNewItemHandler = () => {
    nextModal(true);
    closeModal(false);
  }

  // useEffect(() => {
  //   if (unitDropdownData?.length > 0) {
  //     setFormValue((s) => ({
  //       ...s,
  //       unit_id: isOpen?._id ? unitDropdownData?.map((el) => {
  //         return {
  //           ...el,
  //           label: el?.name,
  //           value: el?._id,
  //         }
  //       })?.filter((el) => (el?.value === isOpen?._id) ? el : '')[0] : unitDropdownData?.map((el) => {
  //         return {
  //           ...el,
  //           label: el?.name,
  //           value: el?._id,
  //         }
  //       })[0],
  //     }))
  //   }

  // }, [unitDropdownData])


  return (
    <div>
      <CommonModal {...unitProps}>
        {/* <div className='addLr_body'> */}
        {/* <CustomSelect
            options={unitDropdownData?.map((el) => {
              return {
                ...el,
                label: el?.name,
                value: el?._id,
              }
            })}
            isCityAddressCode={true}
            isAddButton={true}
            addButtonAction={(e) => addNewItemHandler(e)}
            name="unit_id"
            label="Unit Address"
            placeholder="Unit Address"
            value={formValue?.unit_id ? formValue?.unit_id : ''}
            error={formError["unit_id.label"]}
            onSelect={(data) => onhandleSelect(data, 'unit_id')}
          />
        </div> */}
        <div className='addLr_body'>
          <SingleSelectDropdownInfinite
            label="Unit"
            fetchData={fetchUnit}
            selectedItem={formValue?.unit_id}
            onChange={(data) => onhandleSelect(data, 'unit_id')}
            error={!!formError["unit_id.label"]}
            errorMessage={formError["unit_id.label"]}
            isAddButton={masterChildUnit?.create === 1 ? true : false}
            addButtonAction={(e) => addNewItemHandler(e)}
            pageSize={20}
          />
        </div>
      </CommonModal>

    </div>
  )
}

export default SelectUnitLrModal